<!-- @veltra/icons generated sha256:1e4d8cb061fab16c gen:8 source:src/svg/normal/search.svg -->
<script setup lang="ts">
defineOptions({ name: 'USearch' })
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    viewBox="0 0 24 24"
  >
    <path d="m21 21-4.34-4.34" />
    <circle cx="11" cy="11" r="8" />
  </svg>
</template>
